<!-- 符合性声明 列表 sqm -->
<template>
  <h-list-page class="rohsConformityDeclarationsList_style">
    <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>
        <h-search :title="h_i18n('bf0de2a6d0dcc7ab42c1474ea076c6d5')">
          <h-autocomplete popper-class="planHidden" v-model="searchData.mtlNo" :fetch-suggestions="mtlNoChange"
              :trigger-on-focus="false" @input="() =>
                  searchData.mtlNo.length < 4 ? (plan.showMtlPlan = false) : ''"
                  @clear="plan.showMtlPlan = false" clearable :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')" @blur="detailBlur('showMtlPlan')"
                  @focus="detailFocus('showMtlPlan')">
            </h-autocomplete>
            <h-detail width="400px" top="34px" left="0px">
              <el-table v-show="plan.showMtlPlan" v-loading="data.mtlLoading" :data="data.mtlNoList" border size="small"
                max-height="252" @row-click="clickMtlNo" @mousedown="plan.planBlur = true">
                <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="120"></el-table-column>
                <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
              </el-table>
              <div v-if="plan.showMtlPlan && plan.MtlOver600" style="color: red;height: 20px;background-color: #fff;
                  padding-top: 3px;">
                <span style="padding-left: 10px; font-size: 12px">{{ h_i18n('fb36f45f54ec9c9de745b566c6e60e25') }}</span>
              </div>
            </h-detail>
        </h-search>

        <h-search :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')">
            <h-input v-model="searchData.mtlName" clearable @change="changeNull(searchData.mtlName, 'mtlName')">
            </h-input>
          </h-search>

          <h-search :title="h_i18n('065f4fe3485e8818bb64206abd0d2f5a')">
            <h-input v-model="searchData.supplyFactoryName" clearable @change="changeNull(searchData.supplyFactoryName, 'supplyFactoryName')">
            </h-input>
          </h-search>

          <h-search :title="h_i18n('261aef771e0245a077599b5ca686c499')">
            <h-select v-model="searchData.relateStandard" clearable filterable @change="changeNull(searchData.relateStandard, 'relateStandard')">
              <h-option label="Q/HR0603001" value="HR0603001"></h-option>
              <h-option label="Q/HR0603003" value="HR0603003"></h-option>
            </h-select>
          </h-search>

          <h-search :title="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')">
            <h-select v-model="searchData.status" clearable filterable @change="changeNull(searchData.status, 'status')">
              <h-option :label="h_i18n('a9c09d3297b708f0ff815a93ec5f4145')" value="S"></h-option>
              <h-option :label="h_i18n('f5e626da7e14d2cd3996dcd2627e1c3f')" value="Y"></h-option>
            </h-select>
          </h-search>

          <h-search :title="h_i18n('4457266820aec59e3a6ae4d3d59337eb')">
            <h-select v-model="searchData.isValid" clearable filterable @change="changeNull(searchData.isValid, 'isValid')">
              <h-option :label="h_i18n('c6cc397661432878e10a24834460da0d')" value="Y"></h-option>
              <h-option :label="h_i18n('1abbb1748ef98f00486f7801a290fdb4')" value="N"></h-option>
            </h-select>
          </h-search>

          <h-search :title="h_i18n('0039880117c13787732d259f5bc9f7f5')">
            <h-date-picker @change="TimeChange(searchData.isrtTime, {start:'isrtTimeStart',end:'isrtTimeEnd'})" v-model="searchData.isrtTime"
              type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
          </h-search>

          <template #operate>
          <h-button type="primary" :loading="data.tableLoading" @click="getInfo(true)">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>

    <h-table-card :title="h_i18n('8a6e408b951465dfcc89422d2c111200')" :is-left="0" :is-right="0" :h-data="data.dataOfTable">
      <template #buttonGroup>
        <h-button-group>
          <template v-for="item in data.btnListOfSqm" :key="item.code">
            <template v-for="temp in data.btnCodeList" :key="temp">
              <h-button
                v-if="item.code.includes(temp)"
                type="primary"
                :loading="loadingFunction(temp)"
                @click="btnFunction(temp)">
                <export v-if="temp == 'mkhl_yhwzNew_fhxsm_export1'"/>
                <error v-if="temp == 'mkhl_yhwzNew_fhxsm_invalid1'"/>
                <add-four v-if="temp == 'mkhl_yhwzNew_fhxsm_insert1'"/>
                {{ item.name }}</h-button>
            </template>
          </template>
          <!-- <h-button type="primary" :loading="data.exportLoading" @click="excleBtn">
            <export />
            导出</h-button>
            <h-button type="primary" :loading="data.validBtnLoading" @click="validBtn">
              <error/>
            置为无效</h-button>
            <h-button type="primary" :loading="data.addBtnLoading" v-if="data.roleCode == 'S009'" @click="addBtn">
              <add-four/>
            添加</h-button> -->
            <!-- <h-button type="primary" :loading="data.exportLoading" @click="backOldVersion">
            <history />
          切换旧版</h-button> -->
          <div class="dangerColor" style="display: flex;align-items: center;margin-left: 20px;font-size: 12px">{{ h_i18n('84a84c2d77921398d7f159f5c69ecba1') }}<br/>{{ h_i18n('96bcfc28273a47e8dbfb74d5fdd8c2a4') }}</div>
        </h-button-group>
      </template>

      <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="data.tableLoading" height="540" @selection-change="listCheckBoxChange"
        border :data="data.dataOfTable" size="small" style="width: 100%; min-height: 540px">
        <el-table-column type="selection" width="40" :selectable="selectable"></el-table-column>
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
        <el-table-column prop="status" :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" min-width="70">
          <template #default="{ row }">
            <span v-if="row.status == 'Y'">{{ h_i18n('f5e626da7e14d2cd3996dcd2627e1c3f') }}</span>
            <span v-else-if="row.status == 'S'">{{ h_i18n('a9c09d3297b708f0ff815a93ec5f4145') }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="isValid" :label="h_i18n('4457266820aec59e3a6ae4d3d59337eb')" min-width="70">
          <template #default="{ row }">
            <span v-if="row.isValid == 'Y'">{{ h_i18n('c6cc397661432878e10a24834460da0d') }}</span>
            <span v-else-if="row.isValid == 'N'">{{ h_i18n('1abbb1748ef98f00486f7801a290fdb4') }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" min-width="130"></el-table-column>
        <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" width="200" class-name="textalignleft_style"></el-table-column>
        <el-table-column prop="relateMtlNo" :label="h_i18n('ae6c2f49100d90869604ee4af29e7f0d')" min-width="130"></el-table-column>
        <el-table-column prop="relateStandard" :label="h_i18n('261aef771e0245a077599b5ca686c499')" min-width="130"></el-table-column>
        <el-table-column prop="supplyFactoryName" :label="h_i18n('065f4fe3485e8818bb64206abd0d2f5a')" min-width="130"></el-table-column>
        <el-table-column prop="isrtEmpName" :label="h_i18n('ae27d6f465386eb63210704c8918c6c4')" min-width="90"></el-table-column>
        <el-table-column prop="isrtDate" :label="h_i18n('0039880117c13787732d259f5bc9f7f5')" min-width="170">
          <template #default="{ row }">
            <span>{{ time(row.isrtDate ,6) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="updateTime" :label="h_i18n('a001a226fdc34fd7121f9c4839c759a2')" min-width="170">
          <template #default="{ row }">
            <span>{{ time(row.updateTime ,6) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="" :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')">
          <template #default="{ row }">
            <h-file v-if="row.fileUuid && row.fileName" :name="row.fileName" :delete-type="false" :url="row.fileUuid" @delete="deleteFun"
             :autoOpen='false' @open="openFile(row.fileUuid,row.fileName)"></h-file>
          </template>
        </el-table-column>
        
        <el-table-column prop="" :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" min-width="90" class-name="table_button_style">
          <template #default="{ row }">
            <template v-if="data.roleCode == 'S009'">
              <h-button v-if="row.status == 'Y' && row.isValid == 'Y'" type="danger" @click="YYBtn(row)">{{ h_i18n('8347a927c09a4ec2fe473b0a93f667d0') }}</h-button>
              <h-button v-else-if="row.status == 'Y' && row.isValid == 'N'" type="primary" @click="NYBtn(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</h-button>
              <h-button v-else-if="row.status == 'S' && row.isValid == 'N'" type="primary" @click="NYBtn(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</h-button>
              <h-button v-else-if="row.status == 'S'" type="warning" @click="SBtn(row)">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
            </template>
            <template v-else>
              <h-button type="primary" @click="NYBtn(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</h-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination background @size-change="handleSizeChange" @current-change="getInfo"
        v-model:currentPage="searchData.pageNo" :page-size="10" layout="total, prev, pager, next,jumper"
        :total="data.total">
      </el-pagination>

    </h-table-card>
  </h-list-page>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()
  const searchData = reactive({
    mtlNo:'',
    pageNo: 1,
    pageSize: 10,
  })
  const data = reactive({
    validBtnLoading:false,
    exportLoading:false,
    addBtnLoading:false,
    rowListOfCheck:[],
    dataOfTable:[],
    keepalivestatus:0,
    btnCodeList:[
    "mkhl_yhwzNew_fhxsm_export1","mkhl_yhwzNew_fhxsm_invalid1","mkhl_yhwzNew_fhxsm_insert1"
    ],
    btnListOfSqm:[]
  })
// 按钮事件
const btnFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_yhwzNew_fhxsm_export1": // 导出
  excleBtn()
    break;
    case "mkhl_yhwzNew_fhxsm_invalid1": // 置为无效
    validBtn()
    break;
    case "mkhl_yhwzNew_fhxsm_insert1": // 添加
    addBtn()
    break;
  }
}
// loading事件
const loadingFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_yhwzNew_fhxsm_export1":
    return data.exportLoading
    case "mkhl_yhwzNew_fhxsm_invalid1":
    return data.validBtnLoading
    case "mkhl_yhwzNew_fhxsm_insert1":
    return data.addBtnLoading
  }
}
// 切换旧版
const backOldVersion = () =>{
  if (process.env.NODE_ENV != 'production') {
    window.open(`http://sqm-test.qd-huangdao-test.haier.net/rohs/conformityDeclarations/conformityDeclarations_list?resourceId=7&roleCode=${data.roleCode}&vCode=${data.supplyCode}&supplyCode=${data.supplyCode}&trueName=${data.trueName}&supplyName=${data.supplyName}&userName=${data.userName}&dataFrom=sqm`)
  }else{
    window.open(`https://sqm.haier.net/rohs/conformityDeclarations/conformityDeclarations_list?resourceId=7&roleCode=${data.roleCode}&vCode=${data.supplyCode}&supplyCode=${data.supplyCode}&trueName=${data.trueName}&supplyName=${data.supplyName}&userName=${data.userName}&dataFrom=sqm`)
  }
}
  /**
 * 传高度
 */
 const changeMethod = () => {
  proxy.postThisPageHeight();
};
/**
 * 勾选操作
 * @param {*} rowArr 选中行
 */
 const listCheckBoxChange = (rowArr) => {
  data.rowListOfCheck = rowArr
  // if(data.rowListOfCheck.length == 1){
  //   getTaskId()
  // }
};
// 清除按钮事件
const searchClear = (key) => {
  searchData[key] = undefined;
};
// input为空时undefined
const changeNull = (value, key) => {
  if (value === "") {
    searchData[key] = undefined;
  }
};
// 两个模糊查询相关
const http = reactive({
  mtlSearchHttp: false,
  supplySearchHttp: false,
});
const plan = reactive({
  showMtlPlan: false,
  planBlur: false,
  MtlOver600: false,
  SupplyOver600: false,
  showSupplyPlan: false,
});

// 弹窗失焦
const detailBlur = (v) => {
  if (!plan.planBlur) {
    plan[v] = false;
  }
};
// 弹窗聚焦
const detailFocus = (v) => {
  plan.planBlur = false;
  if (v == "showSupplyPlan") {
    if (searchData.supplyCode.length >= 2) {
      plan[v] = true;
    }
  } else if (v == "showMtlPlan") {
    if (searchData.mtlNo.length >= 4) {
      plan[v] = true;
    }
  }
};
const clickMtlNo = (row) => {
  searchData.mtlNo = row.mtlNo;
  plan.showMtlPlan = false;
};
/**
 * 专用号模糊查询
 */
const mtlNoChange = () => {
  plan.planBlur = false;
  if (http.mtlSearchHttp) http.mtlSearchHttp.cancel();
  http.mtlSearchHttp = axios.CancelToken.source();
  if (searchData.mtlNo.length < 4) {
    plan.showMtlPlan = false;
  } else {
    plan.showMtlPlan = true;
    data.mtlLoading = true;
    proxy.$http({
      method: "POST",
      url: "/base/basicData/searchMaterielList",
      headers: { "content-type": "application/json" },
      data: {
        mtlNo: searchData.mtlNo,
      },
      cancelToken: http.mtlSearchHttp.token,
    })
    .then((res) => {
      data.mtlNoList = res.data.data;
      if (data.mtlNoList.length >= 600) {
        plan.MtlOver600 = true;
        data.mtlLoading = false;
      } else {
        plan.MtlOver600 = false;
        data.mtlLoading = false;
      }
    }).catch((e) => { })
  }
};
// 两个模糊查询结束

// 时间范围选择
const TimeChange = (date, {start,end}) => {
  if (date) {
    searchData[start] = proxy.time(date[0]);
    searchData[end] = proxy.time(date[1]);
  } else {
    searchData[start] = undefined;
    searchData[end] = undefined;
  }
}

// 查询
const getInfo = (flag) => {
  console.log(searchData)
  if (true == flag) {
    searchData.pageNo = 1;
  }
  data.tableLoading = true;
  proxy.$http({
    url: "/base/rohs/getConformityDeclarationsPageInfo",
    method: "post",
    data: {
      ...searchData,
      mtlNo: searchData.mtlNo || undefined,
      name:undefined,
      nickName:undefined,
      isrtTime:undefined,
      fixConfig:true,
    }
  }).then(res=>{
    data.dataOfTable = res.data.data.records
    data.total = res.data.data.total
  }).catch(err=>{
    data.dataOfTable = []
    data.total = 0
  }).finally(()=>{
    data.tableLoading = false
  
  })
}

// 导出
const excleBtn = () => {
  if (data.total > 5000) {
    proxy.warning(
      { message: h_i18n('748c802d8fe36ada78520df791295747'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6') },
      {
        confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { },
      }
    );
    return;
  }
  data.exportLoading = true;
  proxy.startLoading(h_i18n('138acdd0bf5c99a9c04ac29e4f571757'));
  proxy.httpFile(
    {
      method: "post",
      url: "/base/rohs/conformityExport",
      data: {
        ...searchData,
        mtlNo: searchData.mtlNo ? searchData.mtlNo : undefined,
        isrtTime:undefined,
        pageSize: undefined,
        pageNo: undefined,
      },
    },
    h_i18n('03e0194cf9706e9e2235a069a5339e99')
  ).then(res=>{
    data.exportLoading = false;
  }).catch(err=>{
    data.exportLoading = false;
    proxy.closeLoading()
  })
}
// 操作-修改
const YYBtn = (row) => {
  proxy.info({title:h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),message:h_i18n('fccf5c70302d570f96e06d4b1c25251f')
    ,confirmButtonText:h_i18n('38cf16f2204ffab8a6e0187070558721'),cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),callback: (action) => {
      if(action == 'confirm'){
        // 自动复制一条数据
        proxy.$http({
          url: "/base/rohs/copyDataByModify?conformityDeclarationsId="+row.conformityDeclarationsId,
          //old /api/rohs/copyDataByModify
          method: "get",
          // params: {
          //   conformityDeclarationsId:row.conformityDeclarationsId,
          //   trueName:data.trueName,
          //   userName:data.userName
          // }
        }).then(res=>{
          if(res.data.data == '1' && res.data.msg == "成功"){
            proxy.success(h_i18n('3b6eb9c667ec1e3a939d3d2b580e8335'))
            setTimeout(() => {
              getInfo()
            }, 10);
          }
          if(res.data.data == '-1'){
            proxy.warning(h_i18n('eacae04478437ea6d4dcd66bd600e94e'))
          }
        }).catch(err=>{

        }).finally(()=>{
        })
      }else{
          
        }
      },
    })
}
// 操作-查看
const NYBtn = (row) => {
  proxy.$router.push({
    name: "rohsConformityDeclarationsDetail",
    query: {
      trueName:data.trueName,
      userName:data.userName,
      dataFrom:'sqm',
      kindType:'sqmDetail',
      supplyCode:row.supplyCode || data.supplyCode,
      supplyName:row.supplyName || data.supplyName,
      conformityDeclarationsId:row.conformityDeclarationsId,
    }
  })
}
// 操作-提交
const SBtn = (row) => {
  proxy.$router.push({
    name: "rohsConformityDeclarationsModify",
    query: {
      trueName:data.trueName,
      userName:data.userName,
      dataFrom:'sqm',
      kindType:'sqmModify',
      supplyCode:row.supplyCode || data.supplyCode,
      supplyName:row.supplyName || data.supplyName,
      conformityDeclarationsId:row.conformityDeclarationsId,
    }
  })
}
// 支持老附件下载
const openFile = (uuid,name) => {
  console.log(uuid,name)
  proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
  // https://sqm.haier.net/downLoadFileNew?type=5&fileUUID=2024/02/03/284771ef-a758-434c-bf22-157de2839076.jpg
  let url = ''
  if(uuid.includes('http')){
    url = "/base/fileDownload/downloadFile?filePath="+uuid.split('https://sqm.haier.net/readFile/')[1]
    // url = "/tosqmfordown/"+uuid.split('https://sqm.haier.net/')[1]
  }else{
    // let uid = process.env.NODE_ENV === "production" ? "http://sqm.haier.net/" :  "http://sqm-test.qd-huangdao-test.haier.net/"
    // let uid = process.env.NODE_ENV === "production" ? "https://sqm.haier.net/" :  "http://sqm-test.qd-huangdao-test.haier.net/"
    // let uid ="https://sqm.haier.net/"
    // url = uid+'downLoadFileNew?type=5&fileUUID='+uuid
    url = '/base/fileDownload/downLoadFileFtp?type=5&fileUUID='+uuid
  }
  // proxy.startLoading('下载中...')
  proxy.httpFile({
    method: "get",
    url: url,
    headers: {'content-type': 'application/json'},
  }, name)
}

/**
* h-file-upload 删除
*/
const deleteFun = () =>{
  postData.fileUuid = ''
  postData.fileName = ''
  data.fileTemp = {}  
}
// 置为无效
const validBtn = () => {
  if(data.rowListOfCheck.length < 1){
    proxy.info(h_i18n('d406f9db158a30728b4a8db172e1d0a5'))
    return
  }
  let conformityDeclarationsIds = data.rowListOfCheck.map(item=>item.conformityDeclarationsId).join(',')
  if(data.rowListOfCheck.some(item=>item.isValid == 'N')){
    proxy.info(h_i18n('de8fc094d64e1c566dd614ae8bf648f0'))
    return
  }else{
    proxy.info({title:h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),message:h_i18n('0f1e7c68852bc8557182ac1c291992ce'),confirmButtonText:h_i18n('38cf16f2204ffab8a6e0187070558721'),cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),callback: (action) => {
      if(action == 'confirm'){
        proxy.$http({
          url: "/base/rohs/updateBatchConformityDeclarationsValid",
          method: "post",
          data: {
            fixConfig:true,
            conformityDeclarationsIds,
            supplyName:data.trueName,
            supplyCode:data.supplyCode,
            // 追加神奇的参数
            name:data.supplyCode,
            nickName:data.supplyName,
          }
        }).then(res=>{
          if(res.data >= '1'){
            proxy.success(h_i18n('3b6eb9c667ec1e3a939d3d2b580e8335'))
            setTimeout(() => {
              getInfo()
            }, 10);
          }else{
            proxy.info(res.data.msg||h_i18n('5fa802bef51f52b1f7bcf35ade3512cf'))
          }
        }).catch(err=>{
          proxy.warning(err)
        }).finally(()=>{

        })
      }else{
          
        }
      },
    })
  }

}

// 添加 
const addBtn = () => {
  proxy.$router.push({
    name: "rohsConformityDeclarationsAdd",
    query: {
      trueName:data.trueName,
      userName:data.userName,
      dataFrom:'sqm',
      kindType:'sqmAdd',
      supplyCode:data.supplyCode,
      supplyName:data.supplyName,
    }
  })
}

onMounted(() => {
  if(route.query.dataFrom != 'sqm'){
    proxy.$router.replace('/404')
    return
  }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { 
          proxy.$router.back()        
        },})
      return
    }
    console.log('================route.query',route.query)
    if (route.query) {
      data.supplyCode = route.query.supplyCode;
      searchData.supplyCode = route.query.supplyCode;
      data.supplyName = route.query.supplyName;
      data.trueName = route.query.trueName||route.query.nickName;
      data.roleCode = route.query.roleCode;
      data.userName = route.query.userName||route.query.nickName;
    }
    if(route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != ''){
      let p = proxy.getButtonFromSqm(route.query.parentId,route.query.roleCode)
      p.then(res=>{
        if(res.length > 0){
          data.btnListOfSqm = res
        }
      })
    }
    getInfo()
  })
  onActivated(() => {
  if (data.keepalivestatus == 0) {
    // console.log("首次打开");
    data.keepalivestatus ++ 
  } else {
    proxy.postThisPageHeight();
    console.log("操作完之后打开");
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { 
          proxy.$router.back()        
        },})
      return
    }
    getInfo()
  }
})
onDeactivated(() => {
})

</script>

<style lang="scss">
.rohsConformityDeclarationsList_style{
  .el-table td.textalignleft_style .cell {
    text-align: left !important;
  }
  .table_button_style{
    padding: 7px 0 !important;
  }
}
.planHidden{
  display: none;
}
</style>